function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import styled from '../styled-components';
import Input from './Input';
import AngleUp from '../icons/AngleUp';
var StepperButton =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "StepperInput__StepperButton",
  componentId: "ncrdj4-0"
})(["flex:1 0 auto;outline:none;border:0;-webkit-appearance:none;padding:0;font-size:11px;width:27px;color:", ";border-left:1px solid ", ";&:first-child{border-top-right-radius:3px;border-bottom:1px solid ", ";}&:last-child{border-bottom-right-radius:3px;}&:hover{background-color:#f9fbfd;}&:active{background-color:#ededed;}"], function (props) {
  return props.theme.color.grey.mid;
}, function (props) {
  return props.theme.color.grey.light;
}, function (props) {
  return props.theme.color.grey.light;
});
var Container =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "StepperInput__Container",
  componentId: "ncrdj4-1"
})(["position:relative;"]);
var ButtonContainer =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "StepperInput__ButtonContainer",
  componentId: "ncrdj4-2"
})(["position:absolute;right:1px;top:1px;bottom:1px;display:flex;flex-direction:column;"]);
var AngleDown =
/*#__PURE__*/
styled(AngleUp).withConfig({
  displayName: "StepperInput__AngleDown",
  componentId: "ncrdj4-3"
})(["transform:rotate(180deg);"]);
var PaddedInput =
/*#__PURE__*/
styled(Input).withConfig({
  displayName: "StepperInput__PaddedInput",
  componentId: "ncrdj4-4"
})(["padding-right:42px;"]);

var Stepper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Stepper, _React$Component);

  function Stepper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Stepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Stepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isNumberToLarge", function (num) {
      return typeof _this.props.maxValue === 'number' && num > _this.props.maxValue;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isNumberToSmall", function (num) {
      return typeof _this.props.minValue === 'number' && num < _this.props.minValue;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "formatNumber", function (num) {
      var numString = "".concat(num);

      if (_this.props.zeroPadToLength && numString.length < _this.props.zeroPadToLength) {
        var padding = new Array(_this.props.zeroPadToLength - numString.length).fill(0).join('');
        return "".concat(padding).concat(num);
      }

      return numString;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTextChange", function (evt) {
      if (evt.target.value === '') {
        _this.props.onChange(evt.target.value);
      }

      var num = parseInt(evt.target.value, 10);

      if (!isNaN(num)) {
        if (_this.isNumberToLarge(num) || _this.isNumberToSmall(num)) {
          return;
        }

        _this.props.onChange(evt.target.value);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onIncrement", function () {
      var num = parseInt(_this.props.value, 10);

      if (!isNaN(num)) {
        var nextNumber = num + 1;

        if (!_this.isNumberToLarge(nextNumber)) {
          _this.props.onChange(_this.formatNumber(nextNumber));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDecrement", function () {
      var num = parseInt(_this.props.value, 10);

      if (!isNaN(num)) {
        var nextNumber = num - 1;

        if (!_this.isNumberToSmall(nextNumber)) {
          _this.props.onChange(_this.formatNumber(nextNumber));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyPress", function (evt) {
      if (evt.keyCode === 38) {
        _this.onIncrement();
      } else if (evt.keyCode === 40) {
        _this.onDecrement();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
      var num = parseInt(_this.props.value, 10);

      if (!isNaN(num)) {
        var formattedNumber = _this.formatNumber(num);

        if (formattedNumber !== _this.props.value) {
          _this.props.onChange(formattedNumber);
        }
      }
    });

    return _this;
  }

  _createClass(Stepper, [{
    key: "render",
    value: function render() {
      return React.createElement(Container, null, React.createElement(PaddedInput, {
        type: "text",
        onChange: this.onTextChange,
        value: this.props.value,
        placeholder: this.props.placeholder,
        onKeyDown: this.onKeyPress,
        onBlur: this.onBlur
      }), React.createElement(ButtonContainer, null, React.createElement(StepperButton, {
        type: "button",
        onClick: this.onIncrement
      }, React.createElement(AngleUp, {
        width: 8
      })), React.createElement(StepperButton, {
        type: "button",
        onClick: this.onDecrement
      }, React.createElement(AngleDown, {
        width: 8
      }))));
    }
  }]);

  return Stepper;
}(React.Component);

export { Stepper as default };